module.exports = __webpack_public_path__ + "img/close.63a87639.svg";